import type { JSX } from 'react';
import type { SortState } from '@/shared/types/table-filters.types';
import { CompanyCard } from './CompanyCard';
import { CompanyTable } from './CompanyTable';
import type { Company } from '../types/company.types';

export interface CompanyListProps {
  companies: Company[];
  isLoading: boolean;
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onEdit: (company: Company) => void;
  onActivate?: ((id: string) => void) | undefined;
  onSuspend?: ((id: string) => void) | undefined;
  onEnterCompany?: ((company: Company) => void) | undefined;
  showStatusActions?: boolean | undefined;
}

/** Desktop table and mobile cards render the same already filtered/sorted companies. */
export function CompanyList({
  companies,
  isLoading,
  sort,
  onToggleSort,
  showStatusActions = false,
  ...itemHandlers
}: CompanyListProps): JSX.Element {
  if (isLoading) {
    return <div className="text-center py-8 text-muted-foreground">Loading companies...</div>;
  }

  if (companies.length === 0) {
    return <div className="text-center py-8 text-muted-foreground">No companies found</div>;
  }

  return (
    <>
      <div className="hidden md:block">
        <CompanyTable
          companies={companies}
          sort={sort}
          onToggleSort={onToggleSort}
          showStatusActions={showStatusActions}
          {...itemHandlers}
        />
      </div>

      <div className="grid gap-4 md:hidden">
        {companies.map((company) => (
          <CompanyCard
            key={company.id}
            company={company}
            showStatusActions={showStatusActions}
            {...itemHandlers}
          />
        ))}
      </div>
    </>
  );
}
